var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7_16556",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7_16556",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABhElEQVRoge2YTU4CQRCFn248gopXYkeMC7cYXHkHr2SIG3+WKisvARcY3UmC1VGSsVuYrp+ektgveQsWU/V9wzDAADU1NX1nSF1QV8wuqdcOvEnm4MO3JdyjEVg58CaRXkJ/RqArp9QP7KhAFzxLYI86oc6o7x1Df2u4TIZK+KVUYEB9FEDHnSvhzyUC+0bwuQLb4CERuDSCz7mEuuBFArPogCn1MOdAZnLgAYHAW3TAkQ3vj+TCAwKB0vddDryIp6QAF17EU0pAAh/S/u2UdVsuISCFD1n/dsr+YrQW0MCLYinQOzxgJ+ACD9gIuMEDegEpPPvDuikaAc2ZZ98uN0UqMEIKH16fFd5rNij+s86B1+w1G9QW4MJr9poNan8IRz3uLTfIa28V8N5bBbz3VgHvvTsv0ESDSjwTijOIdjaaYS/RsBvqsRJwW8Ls22jns2bgFdK3s++ONQIH1FdH+Dt8PdpX5YT64AB/D8PLNZyFC+oT0uellm2+d4xhcOZrav5bPgHdpEPRHsOQTwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/external_link_icon.33200158af0b1c088b75277fd8e443ae.svg";
export { ForwardRef as ReactComponent };